// One change badge for every KPI (charts-02, charts-08): the arrow says which
// way the number moved, the colour whether that is good (an expense that rose
// is a red UP arrow), and a change that rounds to zero says so without an
// arrow. Screen readers hear the words, not the glyphs.
const FLAT = 0.05;
// From 1000% the figure says nothing more: the chip reads ">999%".
const CAP = 1000;

export function deltaWords(value: number, context = 'vs last year'): string {
  if (Math.abs(value) < FLAT) return `no change ${context}`;
  if (Math.abs(value) >= CAP) return `${value > 0 ? 'up' : 'down'} more than 999% ${context}`;
  return `${value > 0 ? 'up' : 'down'} ${Math.abs(value).toFixed(1)}% ${context}`;
}

export function DeltaChip({ value, favorable, context = 'vs last year', onAccent = false, className = '' }: {
  value: number;
  favorable?: boolean;
  context?: string;
  onAccent?: boolean;
  className?: string;
}) {
  if (!Number.isFinite(value)) return null;
  const flat = Math.abs(value) < FLAT;
  const good = favorable ?? value > 0;
  const tone = onAccent ? 'text-white' : flat ? 'text-muted' : good ? 'text-success' : 'text-danger';
  return (
    <span role="img" aria-label={deltaWords(value, context)}
      className={`inline-flex items-center gap-0.5 whitespace-nowrap text-[0.6875rem] font-semibold tabular-nums ${tone} ${className}`.trim()}>
      {flat ? '0% · no change' : <><span aria-hidden="true">{value > 0 ? '↑' : '↓'}</span>{Math.abs(value) >= CAP ? '>999%' : `${Math.abs(value).toFixed(1)}%`}</>}
    </span>
  );
}
